import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import type { PaymentActiveCob_charge$key } from './__generated__/PaymentActiveCob_charge.graphql.ts';
import PaymentLinkActiveRoot from './paymentLinkActive/PaymentLinkActiveRoot.tsx';

type PaymentActiveCobProps = {
  charge: PaymentActiveCob_charge$key;
  alwaysShowQrCode?: boolean;
  allowSimulatePayment?: boolean;
};

const PaymentActiveCob = (props: PaymentActiveCobProps): ReactNode => {
  const charge = useFragment<PaymentActiveCob_charge$key>(
    graphql`
      fragment PaymentActiveCob_charge on Charge {
        id
        ...PaymentLinkActiveRoot_charge
      }
    `,
    props.charge,
  );

  return (
    <PaymentLinkActiveRoot
      alwaysShowQrCode={props.alwaysShowQrCode}
      allowSimulatePayment={props.allowSimulatePayment}
      charge={charge}
    />
  );
};

export default PaymentActiveCob;
